var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.337402,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F3F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8374 13V22C11.8374 22.8284 12.509 23.5 13.3374 23.5H19.3374C20.1658 23.5 20.8374 22.8284 20.8374 22V13H11.8374Z",
    fill: "#26875C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8374 10.375V10.25C17.8374 9.69772 17.3897 9.25 16.8374 9.25H15.8374C15.2851 9.25 14.8374 9.69772 14.8374 10.25V10.375H11.5874C11.3113 10.375 11.0874 10.5989 11.0874 10.875V11C11.0874 11.2761 11.3113 11.5 11.5874 11.5H21.0874C21.3635 11.5 21.5874 11.2761 21.5874 11V10.875C21.5874 10.5989 21.3635 10.375 21.0874 10.375H17.8374Z",
    fill: "#26875C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashButton);
export default __webpack_public_path__ + "static/media/TrashButton.d1c75da6f3fbe87c591fba7f05e6fca3.svg";
export { ForwardRef as ReactComponent };